{
  "home-page": {
    "meta": {
      "title": "Beauty Booking",
      "description": "online rezervace, sleva na nehty, nabídky na nehty, nabídky na nehty, sleva na obočí, nabídky na obočí, nabídky na obočí, sleva na řasy, nabídky na řasy, nabídky na řasy, sleva na PMU, nabídky na PMU, nabídky na PMU"
    },
    "text": {
      "book-appointment-again": "Rezervace nových termínů v navštívených salonech"
    }
  }
}
